import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { LabProcessingStatusFilterOption } from "@/Common/Models/Lab/Enum/LabProcessingStatusFilterOption";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { ILabsInboxModel } from "../Models/UI/ILabsInboxModel";

import styles from "./LabsInboxSettingsContainerProcessingStatus.module.scss";

function LabsInboxSettingsContainerProcessingStatusSection(props: Readonly<{ LabViewModel: ILabsInboxModel }>): JSX.Element {
    const currentSelection = props.LabViewModel.get("SelectedLabProcessingStatuses");
    const isSelectedByTargetType = (status: LabProcessingStatusFilterOption): boolean => currentSelection?.includes(status) ?? false;

    return (
        <div className={styles.reportStatusSection}>
            <h5>{cacheStore.GetString("ReportStatusLabel")}</h5>
            <CheckboxControl
                id="PendingCancelledCheckbox"
                checked={isSelectedByTargetType(LabProcessingStatusFilterOption.PendingCancelled)}
                label={`${cacheStore.GetString("LabProcessingStatus_PendingLabel")} / ${cacheStore.GetString("LabProcessingStatus_CancelledLabel")}`}
                operation={LocalOperations.Labs.LabInboxSearchSettings_CheckboxChange}
                target={CheckboxTarget.Myle_Labs_ProcessingStatus_PendingCancelled}
                DivWrap
            />
            <CheckboxControl
                id="PartialCheckbox"
                checked={isSelectedByTargetType(LabProcessingStatusFilterOption.Partial)}
                label={cacheStore.GetString("LabProcessingStatus_PartialLabel")}
                operation={LocalOperations.Labs.LabInboxSearchSettings_CheckboxChange}
                target={CheckboxTarget.Myle_Labs_ProcessingStatus_Partial}
                DivWrap
            />
            <CheckboxControl
                id="PreliminaryCheckbox"
                checked={isSelectedByTargetType(LabProcessingStatusFilterOption.Preliminary)}
                label={cacheStore.GetString("LabProcessingStatus_PreliminaryLabel")}
                operation={LocalOperations.Labs.LabInboxSearchSettings_CheckboxChange}
                target={CheckboxTarget.Myle_Labs_ProcessingStatus_Preliminary}
                DivWrap
            />
            <CheckboxControl
                id="FinalCheckbox"
                checked={isSelectedByTargetType(LabProcessingStatusFilterOption.Final)}
                label={cacheStore.GetString("LabProcessingStatus_FinalLabel")}
                operation={LocalOperations.Labs.LabInboxSearchSettings_CheckboxChange}
                target={CheckboxTarget.Myle_Labs_ProcessingStatus_Final}
                DivWrap
            />
            <CheckboxControl
                id="OthersCheckbox"
                checked={isSelectedByTargetType(LabProcessingStatusFilterOption.Other)}
                label={cacheStore.GetString("OtherLabel")}
                operation={LocalOperations.Labs.LabInboxSearchSettings_CheckboxChange}
                target={CheckboxTarget.Myle_Labs_ProcessingStatus_Others}
                DivWrap
            />
        </div>
    );
}

export { LabsInboxSettingsContainerProcessingStatusSection };
